// API publique du moteur SES interne (signature des conventions).
// Aucune authentification : l'accès est gouverné par le token du lien personnel.

const base = `${process.env.REACT_APP_API_URL}/api/public/agreement-signature`;
const jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };
// Le tenant est passé en query param (résolu côté backend), comme la page questionnaire-public.
const q = (tenant) => (tenant ? `?tenant=${encodeURIComponent(tenant)}` : '');

export const publicSignatureApi = {
  async getSignInfo(token, tenant) {
    const resp = await fetch(`${base}/${token}${q(tenant)}`, { method: 'GET', headers: jsonHeaders });
    return resp.json();
  },

  async requestOtp(token, tenant) {
    const resp = await fetch(`${base}/${token}/otp${q(tenant)}`, { method: 'POST', headers: jsonHeaders, body: '{}' });
    return resp.json();
  },

  async sign(token, payload, tenant) {
    const resp = await fetch(`${base}/${token}/sign${q(tenant)}`, {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify(payload),
    });
    return resp.json();
  },

  async downloadSigned(token, tenant) {
    const resp = await fetch(`${base}/${token}/download-signed${q(tenant)}`, { method: 'GET', headers: jsonHeaders });
    return resp.json();
  },
};

export default publicSignatureApi;
